export default from './Quiz';



// WEBPACK FOOTER //
// ./src/sharedComponents/Quiz/index.js